import { render, staticRenderFns } from "./dicPortReout.vue?vue&type=template&id=0d20850b&scoped=true&"
import script from "./dicPortReout.vue?vue&type=script&lang=js&"
export * from "./dicPortReout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20850b",
  null
  
)

export default component.exports